module.exports = __webpack_public_path__ + "static/media/discord.4a23a744.png";